import { getStage, isContentPreview } from "src/context";
import { ContentPreviewWarning } from "./ContentPreviewWarning";
import { LocalProdWarning } from "./LocalProdWarning";

export function UnauthedHeader() {
  return (
    <div>
      {isContentPreview() && <ContentPreviewWarning />}
      {getStage() === "local-prod" && <LocalProdWarning />}
    </div>
  );
}
